import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="flex min-h-screen flex-col items-center justify-center bg-[#FFFFFF] px-6 text-center text-slate-900">
      <Link to="/" className="mb-10 flex items-center gap-3">
        <img src="/logo.png" alt="PRE-IPO EXPERT" className="h-10 w-10 rounded-full object-contain" />
        <span className="font-display text-lg font-semibold tracking-[0.18em]">PRE-IPO <span className="text-[#6D28D9]">EXPERT</span></span>
      </Link>
      <div className="max-w-md border border-slate-200 bg-[#F6F4FD]/70 p-10">
        <XCircle className="mx-auto h-9 w-9 text-slate-500" />
        <h1 className="font-display mt-5 text-xl font-semibold tracking-tight">Payment cancelled</h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-500">No charge was made. You can pick a slot and try again whenever you're ready.</p>
        <Link data-testid="payment-cancel-retry" to="/#consult" className="mt-8 inline-flex items-center gap-2 border border-[#6D28D9]/40 px-6 py-3 font-mono2 text-[11px] uppercase tracking-[0.2em] text-[#6D28D9] transition-colors hover:bg-[#6D28D9]/10">
          Back to booking
        </Link>
      </div>
    </div>
  );
}
